import { formatMoney } from "utils/storefront/format-resource";
import {
  setRechargeDataToStorage,
  getRechargeDataFromStorage,
} from "./product-form";
import ProductSliders from "./product-sliders";
import extractAndFormat from "../utils/extract-and-format";
import "./product-yotpo-review.css";
import "./product-yotpo-subscription.css";
import "./product-recharge-styles.css";
import "./product-findation-widget.css";
import "./product-afterpay.css";
import "./product-tooltip.css";
import "./product.css";
import AjaxService from "../cart/ajax-service";
import "./countdown";
import "./highlight-block";

export default (
  element,
  {
    product,
    productInformation,
    earnUp,
    showFindationWidget,
    findationSetId,
    findationApiKey,
    variants,
    points,
  }
) => {
  let currentVariant = null;
  let currentVariantJson = null;
  let cart = null;
  let alreadyAddedQty = null;
  const input = element.querySelector("[data-quantity-input]");
  const ctaPriceSticky = element.querySelector("[data-sticky-price]");
  const ctaPrice = element.querySelector("[data-button-price]");
  const stickyImage = document.querySelector("[data-sticky-image]");
  const productForm = document.getElementById("productForm");

  let smallSliders = null;
  let largeSliders = null;
  let isExpanded = false;

  const rewardsSliderRender = () => {
    const rewardsPoints = document.querySelectorAll(".rewards-points");
    let yotpoPoints = Math.floor(
      currentVariantJson.price.amount * points.pointPrice
    );

    rewardsPoints.forEach((element) => {
      if (element.innerHTML.includes("[points]")) {
        element.innerHTML = element.innerHTML.replace(
          "[points]",
          `<span
              class="swell-product-helper bg-supergoop-yellow pl-[5px] py-[1px]"
              class=" bg-supergoop-yellow pl-[5px] py-[1px]"
            >${yotpoPoints}</span>`
        );

        element.innerHTML = element.innerHTML.replace(
          " points ",
          `<span class="bg-supergoop-yellow pr-[5px] rounded-br-[4px] py-[1px] rounded-tr-[4px]"> points</span> `
        );
        element.innerHTML = element.innerHTML.replace(
          earnUp,
          `<span class="bg-supergoop-yellow pl-[5px] rounded-bl-[4px] py-[1px] rounded-tl-[4px] -mr-[3px]"> Earn up to</span> `
        );
      } else {
        const yotpoWrapper = document.querySelector(".swell-product-helper");
        if (yotpoWrapper) {
          yotpoWrapper.innerHTML =
            currentVariantJson.price.amount * points.pointPrice;
          yotpoWrapper.dataset.priceCents = yotpoPoints * points.pointPrice;
        }
      }
    });
  };

  const showFindationWidgetFunc = () => {
    const initWidget = () => {
      window.Findation = window.Findation || {};
      Findation.init(
        document.getElementById("findation-widget-button"),
        findationApiKey,
        {
          productId: product.id,
          searchSetLookupReference: findationSetId,
        }
      );
    };

    const attemptInit = () => {
      if (window.Findation) {
        initWidget();
        return true;
      }
      return false;
    };

    if (!attemptInit()) {
      const interval = setInterval(() => {
        if (attemptInit()) {
          clearInterval(interval);
        }
      }, 100);
    }
  };

  const quantityLogic = () => {
    const minus = element.querySelector("[data-button-minus]");
    const plus = element.querySelector("[data-button-plus]");

    if (!currentVariant || !currentVariant.available) return;

    plus.addEventListener("click", () => {
      if (
        currentVariantJson.metafields?.cartValidation &&
        currentVariantJson.metafields?.cartValidation?.quantityLimit <=
          alreadyAddedQty + +input.value
      ) {
        plus.classList.add("pointer-events-none");
      } else {
        plus.classList.remove("pointer-events-none");
      }
      input.value = +input.value + 1;
      updateButtonPrice(input.value);
    });

    minus.addEventListener("click", () => {
      const errorMessage = document.querySelector("[data-quantity-message]");
      if (errorMessage) {
        !errorMessage.classList.contains("hidden") &&
          errorMessage.classList.add("hidden");
      }
      if (
        currentVariantJson.metafields?.cartValidation &&
        currentVariantJson.metafields?.cartValidation?.quantityLimit <=
          alreadyAddedQty + +input.value
      ) {
        plus.classList.add("pointer-events-none");
      } else {
        plus.classList.remove("pointer-events-none");
      }
      if (input.value > 1) input.value = +input.value - 1;

      updateButtonPrice(input.value);
    });
  };

  function updateOptions(optionType, currentOption, product, element) {
    const optionPosition = product.options.indexOf(optionType) + 1;
    const filteredVariants = product.variants.filter((variant) => {
      return Object.values(variant).includes(currentOption);
    });

    const optionSelector =
      optionType === "Size"
        ? "[data-product-option-size]"
        : "[data-product-option-color]";
    const options = element.querySelectorAll(optionSelector);
    let visibleCount = 0;

    options.forEach((option) => {
      const optionValue = option.value;
      const isVisible = filteredVariants.some((variant) => {
        return variant[`option${optionPosition}`] === optionValue;
      });

      option.classList.toggle("disabled", !isVisible);
      option.parentNode.classList.toggle("hidden", !isVisible);
      if (isVisible) {
        visibleCount++;
      } else {
        option.checked = false;
      }
    });
  }

  const hideVariantblocks = (e, options) => {
    if (!e || !options) {
      return;
    }
    const { target } = e;
    const forAttr = target.getAttribute("for");
    const filteredOptions = Array.from(options).filter((option) => {
      const optionAttrFor = option.getAttribute("for");
      return forAttr != optionAttrFor;
    });

    const filteredVariants = product.variants.filter((variant) => {
      return variant.options.some((option) => {
        return target.value == option;
      });
    });

    filteredOptions.forEach((option) => {
      const someIncludes = filteredVariants.some((variant) => {
        return variant.title.includes(option.value);
      });
      if (!someIncludes) {
        option.parentNode.parentNode.classList.add("hidden");
      } else {
        option.parentNode.parentNode.classList.remove("hidden");
      }
    });
  };

  const updateURL = (currentVariant) => {
    if (window.location.toString().includes("products/")) {
      const searchParams = new URLSearchParams(window.location.search);
      const id = currentVariant.id;
      searchParams.set("variant", id);
      const newRelativePathQuery = `${
        window.location.pathname
      }?${searchParams.toString()}`;
      window.history.pushState(null, "", newRelativePathQuery);
    }
  };

  const updateProductSchema = (currentVariantJson) => {
    const skioPlanPicker = document.querySelector("skio-plan-picker");
    const selectedSellingPlanId = skioPlanPicker?.selectedSellingPlan?.id;

    const price = selectedSellingPlanId
      ? skioPlanPicker.selectedVariant.selling_plan_allocations.find(
          (spa) => spa.selling_plan_id === selectedSellingPlanId
        ).price / 100
      : currentVariantJson.price.amount;

    const offers = {
      "@type": "Offer",
      url: window.location.href,
      priceCurrency: currentVariantJson.price.currencyCode,
      price: price.toFixed(1),
      itemCondition: "https://schema.org/NewCondition",
      availability: "https://schema.org/InStock",
      hasMerchantReturnPolicy: { "@id": "#return_policy" },
    };
    let schemaScript = document.querySelector("script[data-pdp-richdata]");
    if (schemaScript) {
      const schema = JSON.parse(schemaScript.textContent);
      const newProductSchema = {
        ...schema[0],
        offers: [offers],
      };
      const newSchema = [newProductSchema, schema[1]];
      schemaScript.textContent = JSON.stringify(newSchema, null, 2);
    }
  };

  const getCurrentVariant = (
    e,
    colorChange = false,
    sizeChange = false,
    ScentChange = false
  ) => {
    const form = element.querySelector("[data-product-form]");
    const addToCart = element.querySelector("[data-add-to-cart]");
    const dataOneSize = element.querySelector("[data-one-size]");
    const customOptions = element.querySelectorAll(".custom-options");
    const customOptionsInput = element.querySelectorAll(
      ".custom-options input"
    );
    const selectedSizeValue = element.querySelector(
      "[data-product-option-size]:checked"
    )?.value;

    if (customOptions.length && customOptionsInput.length) {
      const customOptionValues = Array.from(customOptions)
        .map((block, index) => {
          const checkedInput = block.querySelector("input:checked");
          return checkedInput ? checkedInput.value : null;
        })
        .filter((value) => value !== null);

      let filteredVariant = product.variants.filter(variant => {
        return customOptionValues.includes(variant.option1) && variant.option2 == selectedSizeValue
      });

      if (filteredVariant.length === 0) {
        filteredVariant = product.variants.filter((variant) => {
          if (customOptionValues.length === 0) return false;

          return customOptionValues.every((value, index) => {
            const optionKey = `option${index + 1}`;
            return variant[optionKey] === value;
          });
        });
      }

      const filteredVariantJson = variants.filter(variant => {
        return variant.selectedOptions.some(option => {
          return customOptionValues.includes(option.value)
        })
      })

      if (filteredVariant && filteredVariant[0]) {
        currentVariant = filteredVariant[0];
      }
      if (filteredVariantJson && filteredVariantJson[0]) {
        currentVariantJson = filteredVariantJson[0];
      }

      currentVariantJson = variants.find((variant) => {
        return variant.variantId == currentVariant.id;
      });

      const select = form.querySelector('[name="id"]');
      if (select) {
        select.value = currentVariant.id;
        select.dispatchEvent(new Event("change"));
      }

      hideVariantblocks(e, customOptionsInput);
      updateButtonPrice(1);
      addToCart.disabled = !currentVariant.available ? true : false;

      updateURL(currentVariant);

      if (ScentChange) {
        const optionPosition = product.options.indexOf("Scent") + 1;
        updateOptions(
          "Size",
          currentVariant[`option${optionPosition}`],
          product,
          element
        );
      }

      if (smallSliders) smallSliders.reinit(currentVariantJson);
      if (largeSliders) largeSliders.reinit(currentVariantJson);

      if (
        stickyImage &&
        currentVariantJson &&
        currentVariantJson.image &&
        currentVariantJson.image.src
      ) {
        stickyImage.src = currentVariantJson.image.src;
        const stickyOptionSize = element.querySelector(
          "[data-sticky-option-size]"
        );
        const stickyOptionsColor = element.querySelector(
          "[data-sticky-option-color]"
        );
        stickyOptionSize.querySelector(
          "[data-sticky-option-size-value]"
        ).innerHTML =
          currentVariantJson.selectedOptions &&
          currentVariantJson.selectedOptions[0] &&
          currentVariantJson.selectedOptions[0].value;
        stickyOptionsColor.querySelector(
          "[data-sticky-option-color-value]"
        ).innerHTML =
          currentVariantJson.selectedOptions &&
          currentVariantJson.selectedOptions[1] &&
          currentVariantJson.selectedOptions[1].value;
      }
      return;
    }

    const currentVariantOptionColor = element.querySelector(
      "[data-product-option-color]:checked"
    );
    const currentVariantOptionSize = dataOneSize
      ? dataOneSize.innerHTML
      : element.querySelector("[data-product-option-size]:checked")?.value;
    const currentVariantOptionSizeElement = element?.querySelector(
      "[data-product-option-size]:checked"
    );
    const currentVariantOptionScentElement = document.querySelector(
      "[data-product-option-custom]:checked"
    );

    if (
      product.variants.length == 1 &&
      !currentVariantOptionColor &&
      !currentVariantOptionSize &&
      !currentVariantOptionScentElement
    ) {
      currentVariantJson = variants[0];
      currentVariant = product.variants[0];

      if (
        stickyImage &&
        currentVariantJson &&
        currentVariantJson.image &&
        currentVariantJson.image.src
      ) {
        stickyImage.src = currentVariantJson.image.src;
      }

      updateButtonPrice(1);
      addToCart.disabled = !currentVariant.available ? true : false;

      return;
    }

    if (!currentVariantOptionColor && !currentVariantOptionSize) {
      return;
    }

    const checkColorExist =
      currentVariantOptionColor && currentVariantOptionColor?.value;

    const choosenColorOption = element.querySelector(
      "[data-product-option-color]:checked"
    );
    const choosenSizeOption = element.querySelector(
      "[data-product-option-size]:checked"
    );

    currentVariant = product.variants.filter((variant) => {
      if (choosenColorOption && choosenSizeOption) {
        return (
          Object.values(variant).includes(choosenColorOption?.value) &&
          Object.values(variant).includes(choosenSizeOption?.value)
        );
      }

      if (!choosenColorOption && choosenSizeOption) {
        return Object.values(variant).includes(choosenSizeOption?.value);
      }

      if (choosenColorOption && !choosenSizeOption) {
        return Object.values(variant).includes(choosenColorOption?.value);
      }

      if (!choosenColorOption && !choosenSizeOption) {
        return variant;
      }
    })[0];

    updateURL(currentVariant);

    const select = form.querySelector('[name="id"]');
    if (select) {
      select.value = currentVariant.id;
      select.dispatchEvent(new Event("change"));
    }

    if (colorChange) {
      const optionPosition = product.options.indexOf("Color") + 1;
      updateOptions(
        "Size",
        currentVariant[`option${optionPosition}`],
        product,
        element
      );
    }

    if (sizeChange) {
      const optionPosition = product.options.indexOf("Size") + 1;
      updateOptions(
        "Color",
        currentVariant[`option${optionPosition}`],
        product,
        element
      );
    }

    currentVariantJson = variants.find((variant) => {
      return variant.variantId == currentVariant.id;
    });

    if (smallSliders) smallSliders.reinit(currentVariantJson);
    if (largeSliders) largeSliders.reinit(currentVariantJson);
    rewardsSliderRender();
    updateProductSchema(currentVariantJson);
    const colorDescription = element.querySelector("[data-color-description]");
    const colorMessage = element.querySelector("[data-color-message]");
    const colorChoosenOption = element.querySelector("[data-choosen-variant]");
    const sizeChoosenOption = element.querySelector(
      "[data-choosen-variant-size]"
    );
    const stickyOptionSize = element.querySelector("[data-sticky-option-size]");
    const stickyOptionsColor = element.querySelector(
      "[data-sticky-option-color]"
    );

    if (colorDescription) {
      colorDescription.innerHTML = currentVariantJson.shadeDescription;
    }

    if (colorMessage) {
      colorMessage.innerHTML = currentVariantJson?.shadeMessage || "";
      currentVariantJson?.shadeMessage
        ? colorMessage.classList.remove("hidden")
        : colorMessage.classList.add("hidden");
    }

    if (colorChoosenOption) {
      colorChoosenOption.innerHTML = checkColorExist
        ? currentVariantOptionColor.value
        : "";
      if (stickyOptionsColor) {
        stickyOptionsColor.querySelector(
          "[data-sticky-option-color-value]"
        ).innerHTML = checkColorExist ? currentVariantOptionColor.value : "";
      }
    } else {
      stickyOptionsColor && stickyOptionsColor.classList.add("hidden");
    }

    if (sizeChoosenOption) {
      sizeChoosenOption.innerHTML = dataOneSize
        ? dataOneSize.innerHTML
        : element.querySelector("[data-product-option-size]:checked")?.value;
      if (stickyOptionSize)
        stickyOptionSize.querySelector(
          "[data-sticky-option-size-value]"
        ).innerHTML = dataOneSize
          ? dataOneSize.innerHTML
          : element.querySelector("[data-product-option-size]:checked")?.value;
    } else {
      stickyOptionSize && stickyOptionSize.classList.add("hidden");
    }

    const currentSizes = element.querySelectorAll("[data-product-option-size]");
    currentSizes.forEach((size) => {
      let correctVariant;
      if (currentVariantOptionColor) {
        correctVariant = variants.find(
          (variant) =>
            variant.title ==
            `${currentVariantOptionColor.value} / ${size.value}`
        );
      } else {
        correctVariant = variants.find((variant) =>
          variant.title.includes(size.value)
        );
      }
      size.parentNode.parentNode.querySelector(
        "[data-variant-description]"
      ).innerHTML = correctVariant?.shortDescription || "";
    });

    if (currentVariantOptionSizeElement) {
      currentVariantOptionSizeElement.parentNode.parentNode
        .querySelector("[data-variant-description]")
        .classList.replace("text-grey-5C", "text-grey-2A");
    }

    if (
      stickyImage &&
      currentVariantJson &&
      currentVariantJson.image &&
      currentVariantJson.image.src
    ) {
      stickyImage.src = currentVariantJson.image.src;
    }

    updateButtonPrice(1);
    addToCart.disabled = !currentVariant.available ? true : false;
  };

  const updateButtonPrice = (qty) => {
    const ctaPrice = element.querySelector("[data-button-price]");
    const productPrice = element.querySelector("[data-product-price]");
    const productOldPrice = element.querySelector("[data-product-old-price]");
    const priceHolder = element.querySelector(".price");
    const skioPlanPicker = element.querySelector("skio-plan-picker");
    const selectedSellingPlanId = skioPlanPicker?.selectedSellingPlan?.id;

    const price = selectedSellingPlanId
      ? skioPlanPicker.selectedVariant.selling_plan_allocations.find(
          (spa) => spa.selling_plan_id === selectedSellingPlanId
        ).price / 100
      : currentVariantJson.price.amount;

    if (ctaPrice) {
      if (currentVariantJson.compareAtPrice.amount > 0) {
        ctaPrice.innerHTML = `${extractAndFormat(
          formatMoney({ amount: price * Number(qty) })
        )} <span class="inline ml-[6px] line-through">${extractAndFormat(
          formatMoney({ amount: currentVariantJson.compareAtPrice.amount * 1 })
        )}</span>`;
      } else {
        ctaPrice.innerHTML = extractAndFormat(
          formatMoney({ amount: price * Number(qty) })
        );
      }
    }

    if (ctaPriceSticky) {
      if (currentVariantJson.compareAtPrice.amount > 0) {
        ctaPriceSticky.innerHTML = `${extractAndFormat(
          formatMoney({ amount: price * Number(qty) })
        )} <span class="inline ml-[6px] line-through">${extractAndFormat(
          formatMoney({ amount: currentVariantJson.compareAtPrice.amount * 1 })
        )}</span>`;
      } else {
        ctaPriceSticky.innerHTML = extractAndFormat(
          formatMoney({ amount: price * Number(qty) })
        );
      }
    }

    updateProductSchema(currentVariantJson);

    if (productPrice) {
      productPrice.innerHTML = extractAndFormat(
        formatMoney({ amount: price * 1 })
      );
    }

    if (productOldPrice) {
      if (currentVariantJson.compareAtPrice.amount > 0) {
        productOldPrice.classList.remove(
          "hidden",
          currentVariantJson.compareAtPrice.amount > 0
        );
        priceHolder?.classList.add(
          "price--on-sale",
          currentVariantJson.compareAtPrice.amount > 0
        );
        productOldPrice.innerHTML = extractAndFormat(
          formatMoney({ amount: currentVariantJson.compareAtPrice.amount * 1 })
        );
      } else {
        productOldPrice.classList.add(
          "hidden",
          currentVariantJson.compareAtPrice.amount > 0
        );
        priceHolder?.classList.remove(
          "price--on-sale",
          currentVariantJson.compareAtPrice.amount > 0
        );
        productOldPrice.innerHTML = extractAndFormat(
          formatMoney({ amount: currentVariantJson.compareAtPrice.amount * 1 })
        );
      }
    }
  };

  const addToCartEvent = () => {
    const buttonAddToCart = element.querySelector("[data-add-to-cart]");
    const buttonAddToCartSticky = element.querySelector(
      "[data-sticky-product-button]"
    );
    const productFormElement = element.querySelector("[data-product-form]");

    if (productFormElement && !productFormElement.dataset.eventsBound) {
      productFormElement.addEventListener("submit", handleAddToCart);
      productFormElement.dataset.eventsBound = "true";
    }

    if (buttonAddToCart && !buttonAddToCart.dataset.eventsBound) {
      buttonAddToCart.addEventListener("click", handleAddToCart);
      buttonAddToCart.dataset.eventsBound = "true";
    }

    if (buttonAddToCartSticky && !buttonAddToCartSticky.dataset.eventsBound) {
      buttonAddToCartSticky.addEventListener("click", handleAddToCart);
      buttonAddToCartSticky.dataset.eventsBound = "true";
    }
  };

  const saveRechargeDataToStore = () => {
    const id = currentVariantJson.id.split("/ProductVariant/")[1];
    const allSellingPlans = product.selling_plan_groups
      .filter((spg) => spg.app_id === "SKIO")
      .flatMap((spg) => spg.selling_plans);
    const variantSellingPlans = allSellingPlans.filter((sp) =>
      currentVariantJson.sellingPlanIds.includes(sp.id)
    );
    if (!variantSellingPlans.length) return;

    const rechargeArrayObjects = [...variantSellingPlans].map((input) => {
      return {
        value: input.id,
        text: input.name,
      };
    });
    const obj = { ...getRechargeDataFromStorage() };

    obj[id] = {
      ...rechargeArrayObjects,
    };

    setRechargeDataToStorage(obj);
  };

  const handleAddToCart = async function (e) {
    e.preventDefault();

    if (
      e.currentTarget.classList.contains("notify-me") &&
      e.currentTarget.hasAttribute("data-sticky-product-button")
    ) {
      const notifyMeButton = element.querySelector("#BIS_trigger");
      notifyMeButton.click();
      return;
    }

    await getCart();
    saveRechargeDataToStore();
    const errorMessage = document.querySelector("[data-quantity-message]");

    const itemInCart = cart.items.find((item) => item.id === currentVariant.id);

    if (itemInCart && itemInCart.quantity + Number(input.value) > 20) {
      errorMessage.classList.remove("hidden");
      return;
    }
    if (Number(input.value) > 20) {
      errorMessage.classList.remove("hidden");
      return;
    } else {
      !errorMessage.classList.contains("hidden") &&
        errorMessage.classList.add("hidden");
    }

    const checkIfSubsctibeActive = document.querySelector(
      ".yotpo-radio-subscription-container.yotpo-selected"
    );
    const $skioPlanPicker = document.querySelector("skio-plan-picker");
    const selling_plan = $skioPlanPicker?.selectedSellingPlan?.id;

    const attributes = [];

    const props = {
      detail: {
        payload: {
          merchandiseId: currentVariantJson.id,
          selling_plan,
          attributes,
          quantity: input.value,
        },
      },
    };

    if (currentVariantJson.variantBundle) {
      const bundleDefaultVariantId =
        currentVariantJson.variantBundle.variants[0].id;
      props.detail.payload.merchandiseId = `gid://shopify/ProductVariant/${bundleDefaultVariantId}`;
    }

    const addToCartEvent = new CustomEvent("cart:add", props);

    await document.dispatchEvent(addToCartEvent);

    // need to be used for future updates
    // if (currentVariant.quantityAvailable == alreadyAddedQty) {
    //   const currentVariantId = Number(currentVariant.id.split('/').pop());
    //   const currentCartItemToggle = document.querySelector(`#line-${currentVariantId} .toggle-error`)
    //   currentCartItemToggle.click();
    // }
    return;
  };

  const getCart = async () => {
    cart = await AjaxService.get();

    alreadyAddedQty = cart.items.find(
      (item) => item.id == currentVariant.id
    )?.quantity;
  };

  const observers = [];

  function handleScroll(isNotifyMe) {
    const productForm = document.getElementById("productForm");
    const notifyMeButton = document.querySelector("#BIS_trigger");
    const stickyButton = document.querySelector(".sticky-product-button");
    const headerHeight = document.getElementById(
      "shopify-section-promo-bar"
    ).offsetHeight;
    if (!productForm || !stickyButton) {
      console.error("Required elements are missing");
      return;
    }

    observers.forEach((observer) => {
      observer.disconnect();
    });

    let options = {
      root: null,
      rootMargin: `-${headerHeight}px 0px 0px 0px `,
      threshold: 0,
    };

    const intersect = (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          stickyButton.style.transform = "translateY(100%)";
        } else {
          stickyButton.style.transform = "translateY(0)";
        }
      });
    };

    setTimeout(() => {
      const productFormObserver = new IntersectionObserver(intersect, options);
      productFormObserver.observe(isNotifyMe ? notifyMeButton : productForm);
      observers.push(productFormObserver);
    }, 1000);
  }

  const initCorrectVariant = () => {
    if (window.location && window.location.toString().includes("products/")) {
      const searchParams = new URLSearchParams(window.location.search);
      const idVar = searchParams.get("variant");

      if (idVar) {
        const correctVariant = variants.find((variant) =>
          variant.id.toString().includes(idVar)
        );
        if (correctVariant) {
          correctVariant.selectedOptions.forEach((selectedOption, index) => {
            const optionName = selectedOption.name;
            const optionValue = selectedOption.value;

            if (optionName === "Color") {
              const colorOption = element.querySelector(
                `[data-product-option-color][value="${optionValue}"]`
              );
              if (colorOption) {
                colorOption.checked = true;
              }
            }

            if (optionName === "Size") {
              const sizeOption = element.querySelector(
                `[data-product-option-size][value="${optionValue}"]`
              );
              if (sizeOption) {
                sizeOption.checked = true;
              }
            }

            if (optionName !== "Color" && optionName !== "Size") {
              const customOptionGroups =
                element.querySelectorAll(".custom-options");

              let customOptionIndex = 0;
              for (let i = 0; i <= index; i++) {
                const currentOption = correctVariant.selectedOptions[i];
                if (
                  currentOption.name !== "Color" &&
                  currentOption.name !== "Size"
                ) {
                  if (i === index) break;
                  customOptionIndex++;
                }
              }

              if (customOptionGroups[customOptionIndex]) {
                const customOption = customOptionGroups[
                  customOptionIndex
                ].querySelector(
                  `[data-product-option-custom][value="${optionValue}"]`
                );
                if (customOption) {
                  customOption.checked = true;
                  const customOptionCurrentValueHolder = customOption
                    .closest(".custom-options")
                    ?.querySelector("[data-custom-option-current-value]");
                  if (customOptionCurrentValueHolder) {
                    customOptionCurrentValueHolder.innerText = optionValue;
                  }
                }
              }
            }
          });

          correctVariant.selectedOptions.forEach((selectedOption) => {
            if (selectedOption.name === "Color") {
              const options = element.querySelectorAll(
                "[data-product-option-size]"
              );
              options.forEach((option) => {
                const optionValue = option.value;
                const filteredVariants = product.variants.filter(
                  (variant) => variant.option1 === selectedOption.value
                );

                const isVisible = filteredVariants.some(
                  (variant) => variant.option2 === optionValue
                );

                option.parentNode.classList.toggle("hidden", !isVisible);
              });
            }
          });

          setTimeout(() => {
            getCurrentVariant();
          }, 0);
          return;
        }
      }

      const firstColorOption = element.querySelector(
        "[data-product-option-color]"
      );
      if (firstColorOption) {
        firstColorOption.checked = true;
      }

      const firstSizeOption = element.querySelector(
        "[data-product-option-size]"
      );
      if (firstSizeOption) {
        firstSizeOption.checked = true;
      }

      const firstCustomOption = element.querySelector(
        "[data-product-option-custom]"
      );
      if (firstCustomOption) {
        firstCustomOption.checked = true;
        const customOptionCurrentValueHolder = firstCustomOption
          .closest(".custom-options")
          ?.querySelector("[data-custom-option-current-value]");
        if (customOptionCurrentValueHolder) {
          customOptionCurrentValueHolder.innerText = firstCustomOption.value;
        }
      }

      setTimeout(() => {
        getCurrentVariant();
      }, 0);
    }
  };

  const hideForm = () => {
    if (!currentVariant) {
      return;
    }
    if (!currentVariant.available) {
      productForm.classList.add("hidden");
    } else {
      productForm.classList.remove("hidden");
    }
  };

  const updateInput = () => {
    const input = element.querySelector("[data-quantity-input]");
    input.value = 1;
    hideForm();
  };

  const notifyMeSticky = () => {
    const buttonAddToCartSticky = element.querySelector(
      "[data-sticky-product-button]"
    );
    const productForm = element.querySelector("#productForm");

    const observer = new MutationObserver((mutationList, observer) => {
      if (
        element.querySelector("#BIS_trigger") &&
        buttonAddToCartSticky &&
        productForm.classList.contains("hidden")
      ) {
        buttonAddToCartSticky.classList.add("notify-me");
        buttonAddToCartSticky.querySelector("span:first-child").innerText =
          buttonAddToCartSticky.getAttribute("data-notify-text");
        handleScroll(true);
      }

      if (!productForm.classList.contains("hidden")) {
        buttonAddToCartSticky.classList.remove("notify-me");
        buttonAddToCartSticky.querySelector("span:first-child").innerText =
          buttonAddToCartSticky.getAttribute("data-add-text");
        handleScroll(false);
      }

      setTimeout(() => {
        observer.disconnect();
      }, 10000);
    });

    observer.observe(element.querySelector("#ProductDescription"), {
      childList: true,
    });

    if (
      element.querySelector("#BIS_trigger") &&
      buttonAddToCartSticky &&
      productForm.classList.contains("hidden")
    ) {
      buttonAddToCartSticky.classList.add("notify-me");
      buttonAddToCartSticky.querySelector("span:first-child").innerText =
        buttonAddToCartSticky.getAttribute("data-notify-text");
      handleScroll(true);
    }

    if (!productForm.classList.contains("hidden")) {
      buttonAddToCartSticky.classList.remove("notify-me");
      buttonAddToCartSticky.querySelector("span:first-child").innerText =
        buttonAddToCartSticky.getAttribute("data-add-text");
      handleScroll(false);
    }
  };

  const initExpandButton = () => {
    const closeButtons = element.querySelectorAll(
      ".product-gallery-close-btn"
    );
    const slides = element.querySelectorAll("#smallSliderContainer .swiper-slide");
    if (closeButtons.length === 0) {
      return;
    }

    const gallery = element.querySelector(".product-gallery-swiper");
    if (!gallery) {
      return;
    }

    let isExpanded = false;
    const originalHeight = gallery.style.height || "235px";
    const expandedHeight = "500px";

    const toggleGallery = (forcedIndex) => {
      let currentIndex = 0;

      if (isExpanded && largeSliders && largeSliders.mainSwiperInstance) {
        const instance = largeSliders.mainSwiperInstance;
        currentIndex =
          (typeof instance.realIndex === "number"
            ? instance.realIndex
            : instance.activeIndex) || 0;
      } else if (
        !isExpanded &&
        smallSliders &&
        smallSliders.mainSwiperInstance
      ) {
        const instance = smallSliders.mainSwiperInstance;
        currentIndex =
          (typeof instance.realIndex === "number"
            ? instance.realIndex
            : instance.activeIndex) || 0;
      }

      if (forcedIndex) {
        currentIndex = forcedIndex;
      }

      if (isExpanded) {
        const smallContainer = document.getElementById("smallSliderContainer");
        const largeContainer = document.getElementById("largeSliderContainer");
        const smallThumbsContainer = document.getElementById(
          "smallThumbsContainer"
        );
        const largeThumbsContainer = document.getElementById(
          "largeThumbsContainer"
        );

        smallContainer.classList.remove("hidden");
        largeContainer.classList.add("hidden");

        if (smallThumbsContainer) smallThumbsContainer.style.display = "";
        if (largeThumbsContainer) largeThumbsContainer.style.display = "none";

        setTimeout(() => {
          if (smallSliders && smallSliders.mainSwiperInstance) {
            const inst = smallSliders.mainSwiperInstance;
            if (typeof inst.slideToLoop === "function") {
              inst.slideToLoop(currentIndex, 0);
            } else {
              inst.slideTo(currentIndex, 0);
            }
          }
        }, 50);
      } else {
        const smallContainer = document.getElementById("smallSliderContainer");
        const largeContainer = document.getElementById("largeSliderContainer");
        const smallThumbsContainer = document.getElementById(
          "smallThumbsContainer"
        );
        const largeThumbsContainer = document.getElementById(
          "largeThumbsContainer"
        );

        largeContainer.classList.remove("hidden");
        smallContainer.classList.add("hidden");

        if (smallThumbsContainer) smallThumbsContainer.style.display = "none";
        if (largeThumbsContainer) largeThumbsContainer.style.display = "";

        setTimeout(() => {
          if (largeSliders && largeSliders.mainSwiperInstance) {
            const inst = largeSliders.mainSwiperInstance;
            if (typeof inst.slideToLoop === "function") {
              inst.slideToLoop(currentIndex, 0);
            } else {
              inst.slideTo(currentIndex, 0);
            }
          }
        }, 50);

        setTimeout(() => {
          if (largeSliders && largeSliders.mainSwiperInstance) {
            const swiper = largeSliders.mainSwiperInstance;

            if (!swiper.enabled) {
              swiper.enable();
            }
            if (!swiper.allowTouchMove) {
              swiper.allowTouchMove = true;
            }

            swiper.update();
          }
        }, 100);
      }

      isExpanded = !isExpanded;
    };

    slides.forEach((slide) => {
      slide.addEventListener("click", () => toggleGallery(slide.dataset.swiperSlideIndex));
    });
    closeButtons.forEach((button) => {
      button.addEventListener("click", toggleGallery);
    });
  };

  const initFallbackNavigation = () => {
    const mainSlider = element.querySelector("[data-slider-pg-small]");
    const nextBtn = element.querySelector(".swiper-button-next");
    const prevBtn = element.querySelector(".swiper-button-prev");

    if (!mainSlider || !nextBtn || !prevBtn) {
      return;
    }

    const slides = mainSlider.querySelectorAll(".swiper-slide");
    const wrapper = mainSlider.querySelector(".swiper-wrapper");
    let currentIndex = 0;

    wrapper.style.display = "flex";
    wrapper.style.transition = "transform 0.3s ease";

    const updateSlidePosition = () => {
      const isMobile = window.innerWidth < 648;
      const slideWidth = slides[0].offsetWidth;
      const spaceBetween = 10;

      if (isMobile) {
        const translateX = currentIndex * (slideWidth + spaceBetween);
        wrapper.style.transform = `translateX(-${translateX}px)`;
      } else {
        wrapper.style.transform = `translateX(-${currentIndex * slideWidth}px)`;
      }
    };

    const updateButtonStates = () => {
      prevBtn.style.opacity = currentIndex === 0 ? "0.5" : "1";
      prevBtn.style.pointerEvents = currentIndex === 0 ? "none" : "auto";

      nextBtn.style.opacity = currentIndex >= slides.length - 1 ? "0.5" : "1";
      nextBtn.style.pointerEvents =
        currentIndex >= slides.length - 1 ? "none" : "auto";
    };

    nextBtn.addEventListener("click", () => {
      if (currentIndex < slides.length - 1) {
        currentIndex++;
        updateSlidePosition();
        updateButtonStates();
      }
    });

    prevBtn.addEventListener("click", () => {
      if (currentIndex > 0) {
        currentIndex--;
        updateSlidePosition();
        updateButtonStates();
      }
    });

    updateSlidePosition();
    updateButtonStates();

    setTimeout(() => {
      document.querySelector(".product-skeleton")?.classList.add("hidden");
      document
        .querySelector(".product-page")
        ?.classList.remove("invisible", "h-0");
    }, 200);
  };

  window.testPDPGallery = () => {
    document.body.classList.add("pdp-hypothesis-active");

    if (!smallSliders || !largeSliders) {
      try {
        smallSliders = new ProductSliders(
          "[data-slider-pg-small]",
          "[data-slider-pg-thumbs-small]",
          { isExpanded: false }
        );
        smallSliders.init();

        largeSliders = new ProductSliders(
          "[data-slider-pg-large]",
          "[data-slider-pg-thumbs-large]",
          { isExpanded: true }
        );
        largeSliders.init();
      } catch (error) {
        console.error("❌ ProductSliders initialization failed:", error);
      }
    }

    initExpandButton();

    const isMobile = window.innerWidth < 648;
  };

  window.resetPDPGallery = () => {
    document.body.classList.remove("pdp-hypothesis-active");
  };

  const init = async () => {
    const hypothesisId = "544e23de-3a7a-46a7-a1f0-10853de417e6";

    try {
      if (
        window.shoplift &&
        typeof window.shoplift.isHypothesisActive === "function"
      ) {
        const isActive = await window.shoplift.isHypothesisActive(hypothesisId);
        if (isActive) {
          document.body.classList.add("pdp-hypothesis-active");
          initExpandButton();
        }
      }
    } catch (error) {
      console.error("Error checking hypothesis:", error);
    }

    window.addEventListener("load", () => {
      handleScroll(false);
    });

    if (!smallSliders && !largeSliders) {
      const isHypothesisActive = document.body.classList.contains(
        "pdp-hypothesis-active"
      );

      try {
        if (isHypothesisActive) {
          smallSliders = new ProductSliders(
            "[data-slider-pg-small]",
            "[data-slider-pg-thumbs-small]",
            { isExpanded: false }
          );
          smallSliders.init();

          largeSliders = new ProductSliders(
            "[data-slider-pg-large]",
            "[data-slider-pg-thumbs-large]",
            { isExpanded: true }
          );
          largeSliders.init();
        } else {
          smallSliders = new ProductSliders(
            "[data-slider-pg-top]",
            "[data-slider-pg-thumbs]"
          );
          smallSliders.init();
        }
      } catch (error) {
        console.error("ProductSliders initialization failed:", error);
        initFallbackNavigation();
      }
    }

    setTimeout(() => {
      const swiperElement = element.querySelector("[data-slider-pg-small]");
      if (
        swiperElement &&
        !swiperElement.classList.contains("swiper-initialized")
      ) {
        initFallbackNavigation();
      }
    }, 1000);

    const colorOptions = element.querySelectorAll(
      "[data-product-option-color]"
    );
    const sizeOptions = element.querySelectorAll("[data-product-option-size]");
    const scentOptions = document.querySelectorAll(
      "[data-product-option-custom]"
    );

    initCorrectVariant();
    getCurrentVariant();
    addToCartEvent();
    notifyMeSticky();

    scentOptions.forEach((option) =>
      option.addEventListener("change", async (e) => {
        const customOptionCurrentValueHolder = option
          .closest(".custom-options")
          .querySelector("[data-custom-option-current-value]");
        if (customOptionCurrentValueHolder)
          customOptionCurrentValueHolder.innerText = option.value;
        getCurrentVariant(e, false, false, true);
        updateInput();
        notifyMeSticky();
      })
    );

    colorOptions.forEach((option) =>
      option.addEventListener("change", async (e) => {
        getCurrentVariant(e, true, false);
        updateInput();
        notifyMeSticky();
      })
    );

    sizeOptions.forEach((option) =>
      option.addEventListener("change", async (e) => {
        getCurrentVariant(e, false, true);
        updateInput();
        notifyMeSticky();
      })
    );

    const $planPicker = element.querySelector("skio-plan-picker");
    if (!!$planPicker) {
      $planPicker.addEventListener("skio::update-selling-plan", () =>
        updateButtonPrice(input.value)
      );
    }

    hideForm();

    showFindationWidget && showFindationWidgetFunc();

    quantityLogic();
    await getCart();
    rewardsSliderRender();
  };

  init();
};
